<section class="region-tramites" id="region-tramites">
    <div class="page__content">
        <div class="page__buscador">
            <div class="buscador">
                <h4>{{ 'HOME.TRAMITES.SEARCH.TITLE' | translate }}</h4>
                <p>{{ 'TRAMITE.CONTENT.INDICA_EL_TRAMITE_QUE_DESEAS_REALIZAR' | translate }}</p>
            </div>
            <form id="search-home">
                <div id="search-block">
                    <div class="search">
                        <input type="text" class="form-control" name="buscar" [placeholder]="'PLACEHOLDER.BUSCAR_POR' | translate" [(ngModel)]="filtrarTexto" (keyup)="filter()" />
                    </div>
                </div>
            </form>
            <div class="paddingTop1">
                <p>{{ 'TRAMITE.CONTENT.Y_COMPRUEBA_SI_DISPONEMOS_DEL_MISMO_EN_EL_CATALOGO_QUE_SE_MUESTRA_A_CONTINUACION' | translate }}</p>
            </div>            
        </div>
    </div>
</section>

<section class="region-tramites-resultado">
    <div class="page__content">
        <div>
            <h2 class="title-catalogo">{{ 'HOME.TRAMITES.CATALOG.TITLE' | translate }}</h2>
            <div >
                <ul class="catalogo">
                    <li *ngFor="let procedimientos of filteredProcedimientos">
                        
                        <div class="d-flex flex-wrap">
                            <h3>{{procedimientos.visible?'':'(Privado) '}}{{ procedimientos.nombre }}</h3>
                            <a *ngIf="!tramiteSinFinalizar(procedimientos) && !tramiteSinFirmar(procedimientos)" (click)="navigateNewTramite(procedimientos)" class="activo">
                                <p>
                                    <img src="assets/ordenador-portatil.png " width="30px " [title]="'HOME.TRAMITES.TOOLTIP.TELEMATIC' | translate" /></p>
                            </a>

                            <a *ngIf="tramiteSinFinalizar(procedimientos)" (click)="editTramite(procedimientos)" class="activo">
                                <p>
                                    <img src="assets/ordenador-portatil.png " width="30px " [title]="'HOME.TRAMITES.TOOLTIP.TELEMATIC' | translate" /></p>
                            </a>

                            <a *ngIf="tramiteSinFirmar(procedimientos)" (click)="signTramite(procedimientos)" class="activo">
                                <p>
                                    <img src="assets/ordenador-portatil.png " width="30px " [title]="'HOME.TRAMITES.TOOLTIP.TELEMATIC' | translate" /></p>
                            </a>
                            <!-- <p class="activo">
                                <img src="assets/icon.png" width="25px" title="Pago Presencial" /></p> -->
                            <p class="activo">
                                <a href="https://www.emvs.es/consulta-general?topic=oficinaVirtual&proc={{procedimientos.nombre }}" target="_blank"><img src="assets/chat-icon.png" width="25px" [title]="'HOME.TRAMITES.TOOLTIP.CONTACT' | translate" /></a>
                            </p>
                            <p class="{{ procedimientos.link_ordenanza ? 'activo' : 'no-activo' }}">
                                <a href="{{ procedimientos.link_ordenanza }}" target="_blank"><img src="assets/informacion.png" width="25px" [title]="'HOME.TRAMITES.TOOLTIP.INFO' | translate" /></a>
                            </p>
                            <p class="{{ procedimientos.link_ayuda ? 'activo' : 'no-activo' }}">
                                <a href="{{ procedimientos.link_ayuda }}" target="_blank"><img src="assets/reading-book.png" width="25px" [title]="'HOME.TRAMITES.TOOLTIP.MANUAL' | translate" /></a>
                            </p>
                        </div>
                    </li>
                </ul>
                <p *ngIf="!filteredProcedimientos.length" class="avisoBusqueda">{{ 'HOME.TRAMITES.SEARCH.NO_RESULTS' | translate }}</p>
            </div>
        </div>
        <div class="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" [ngStyle]="{'display':display}">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5>{{ 'CONFIRM_EMAIL.WARNING.TITLE' | translate }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="display='none'">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h6>{{ 'TRAMITE.CONTENT.ESTE_PROCEDIMIENTO_YA_ESTA_INICIADO' | translate }}</h6>
                    <p>{{ 'TRAMITE.CONTENT.PUEDE_CONTINUAR_EL_TRAMITE_O_COMENZAR_UNO_NUEVO' | translate }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="resetTramite()">{{ 'COMMON.BUTTON.DELETE' | translate }}</button>
                    <button type="button" class="btn btn-primary" (click)="resumeTramite()">{{ 'COMMON.BUTTON.CONTINUE' | translate }}</button>
                    <p class="smallInfo">{{ 'TRAMITE.CONTENT.SI_ELIGE_COMENZAR_DE_NUEVO_SU_TRAMITE_EL_ANTERIOR_SERA_ELIMINADO' | translate }}</p>
                </div>
                
                </div>
            </div>
        </div>
        <div class="modal fade show" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" [ngStyle]="{'display':displayFirma}">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5>{{ 'CONFIRM_EMAIL.WARNING.TITLE' | translate }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="displayFirma='none'">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h6>Este procedimiento ya lo ha realizado, falta la firma para formalizarlo</h6>
                    <p>{{ 'TRAMITE.CONTENT.PUEDE_FIRMAR_EL_TRAMITE_O_COMENZAR_UNO_NUEVO' | translate }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn marginTop07 btn-danger" (click)="resetTramiteAfterSign()">{{ 'COMMON.BUTTON.DELETE' | translate }}</button>
                    <fieldset [disabled]="actionProgres"  [class]="isInProgress?'activated':'not-activated'">
                        <boton-listado>                  
                        </boton-listado>
                    </fieldset>                      
                    <p class="smallInfo">{{ 'TRAMITE.CONTENT.SI_ELIGE_COMENZAR_DE_NUEVO_SU_TRAMITE_EL_ANTERIOR_SERA_ELIMINADO' | translate }}</p>
                </div>
                
                </div>
            </div>
        </div>
    </div>
    <form id="firma" (submit)="resultchange($event)" class="">
        <input type="hidden" id="result" />
        <input type="hidden" id="error" />
        <input type="hidden" id="certifcado" />
        </form>

        <div class="page__content">
            <div class="content__inner">
              <div class="register-form">
                <ngx-spinner [name]="'tramite_emvs_spinner'" bdColor  = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true">
                  <p style="color: white" >{{mensajeSpinner}}</p>
                </ngx-spinner>        
              </div>
            </div>
          </div>
</section>